import { BUTTON_TYPES } from '../../../../../../../../constants/button-variants';
import cn from '../../../../../../../../utils/classnames';
import MaterialPricesAndButtons from '../../../../components/material-prices-and-buttons/material-prices-and-buttons';
import { FavoritesMaterialCardVariationProps } from '../../../../favorites-material-card';
import './footer.scss';

const Footer = (props: FavoritesMaterialCardVariationProps) => {
    const isMaterialAcquired = Boolean(props.item.aclId);

    const footerClassNames = cn('footer', isMaterialAcquired ? 'acquired' : 'unacquired');

    return (
        <footer className={footerClassNames}>
            <MaterialPricesAndButtons
                {...props}
                addToCartType='icon'
                removeButtonType='icon'
                downloadButtonType={BUTTON_TYPES.ICON}
            />
        </footer>
    );
};

export default Footer;
